export {default} from './WallCard.provider'
